/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1DocumentCourseDocumentsId200,
  PutApiV1DocumentCourseDocumentsId400,
  PutApiV1DocumentCourseDocumentsId401,
  PutApiV1DocumentCourseDocumentsId404,
  PutApiV1DocumentCourseDocumentsId500,
  PutApiV1DocumentCourseDocumentsIdMutationRequest,
  PutApiV1DocumentCourseDocumentsIdMutationResponse,
  PutApiV1DocumentCourseDocumentsIdPathParams,
} from "../../types/documentCourseDocumentsController/PutApiV1DocumentCourseDocumentsId.ts";
import { courseDocumentsDetailViewModelSchema } from "../courseDocumentsDetailViewModelSchema.ts";
import { courseDocumentsEditorViewModelSchema } from "../courseDocumentsEditorViewModelSchema.ts";

export const putApiV1DocumentCourseDocumentsIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1DocumentCourseDocumentsIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1DocumentCourseDocumentsId200Schema = z.lazy(
  () => courseDocumentsDetailViewModelSchema,
) as unknown as ToZod<PutApiV1DocumentCourseDocumentsId200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1DocumentCourseDocumentsId400Schema =
  z.any() as unknown as ToZod<PutApiV1DocumentCourseDocumentsId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1DocumentCourseDocumentsId401Schema =
  z.any() as unknown as ToZod<PutApiV1DocumentCourseDocumentsId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1DocumentCourseDocumentsId404Schema =
  z.any() as unknown as ToZod<PutApiV1DocumentCourseDocumentsId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1DocumentCourseDocumentsId500Schema =
  z.any() as unknown as ToZod<PutApiV1DocumentCourseDocumentsId500>;

export const putApiV1DocumentCourseDocumentsIdMutationRequestSchema = z.lazy(
  () => courseDocumentsEditorViewModelSchema,
) as unknown as ToZod<PutApiV1DocumentCourseDocumentsIdMutationRequest>;

export const putApiV1DocumentCourseDocumentsIdMutationResponseSchema = z.lazy(
  () => putApiV1DocumentCourseDocumentsId200Schema,
) as unknown as ToZod<PutApiV1DocumentCourseDocumentsIdMutationResponse>;
